import React, { useState, useEffect } from 'react'
import { Form, Button, notification, Row, Col, Input, Card } from 'antd'
import { useDispatch } from 'react-redux'
import { singleXTravelExchangeMarginFxn, updateXTravelExchangeMarginFxn } from '../actions'
import { InputBox, numberToWords } from '../../../components/_utils/appUtils'

const UpdateXTravelExchangeMargin = (props) => {
  let { user } = props
  const dispatch = useDispatch()
  const [xTravelExchangeMargin, setXTravelExchangeMargin] = useState(0.00)
  const [flightMargins, setFlightMargins] = useState({
    domesticMargin: 0,
    internationalMargin: 0,
    fdDomestic: 0,
    fdInternational: 0
  })

  const _updateState = (data) => {
    setFlightMargins((prevState) => {
      return {
        ...prevState,
        ...data
      }
    })
  }

  const fetchExchangeMargin = async () => {
    const data = await dispatch(singleXTravelExchangeMarginFxn({ userId: user._id }))
    if (data) {
      setXTravelExchangeMargin(data.xTravelExchangeMargin)
      setFlightMargins({
        domesticMargin: data.domesticMargin,
        internationalMargin: data.internationalMargin,
        fdDomestic: data.fdDomestic,
        fdInternational: data.fdInternational
      })
    }
  }

  const handleSubmit = async () => {
    /*if (!xTravelExchangeMargin) {
      notification.warning({
        message: 'Enter exchange margin.'
      })
      return
    }

    if (xTravelExchangeMargin > 20) {
      notification.warning({
        message: 'Enter Valid exchange margin.'
      })
      return
    }*/

    if (!flightMargins.domesticMargin) {
      notification.warning({
        message: 'Enter domestic margin.'
      })
      return
    }

    if (!flightMargins.internationalMargin) {
      notification.warning({
        message: 'Enter international margin.'
      })
      return
    }
    const payload = {
      userId: user._id,
      // xTravelExchangeMargin: xTravelExchangeMargin,
      domesticMargin: flightMargins.domesticMargin,
      internationalMargin: flightMargins.internationalMargin,
      fdDomestic: flightMargins.fdDomestic,
      fdInternational: flightMargins.fdInternational
    }
    const resp = await dispatch(updateXTravelExchangeMarginFxn(payload))
    if (resp.success) {
      notification.success({
        message: 'XTravelWorld Exchange margin updated successfully!'
      })
    } else {
      notification.error({
        message: resp.message
      })
    }
  }

  useEffect(() => {
    fetchExchangeMargin()
  }, [])

  const convertToWords = (num) => {
    const [rupees, paise] = num.toFixed(2).split('.')
    return `${rupees} rupee${rupees > 1 ? 's' : ''} and ${paise} paise`
  }

  return (
    <div className='row'>
      <div className='col-lg-12'>
        <Form>
          <div className='form-box mt-4'>
            <div className='d-flex align-items-center mb-3 heading-form'>
              <h5>Update XTravelWorld Exchange Margin</h5>
            </div>

            <div className='card unizportal'>
              <Card title={<b>Flight Margin</b>}>
                <Row gutter={24}>
                  <Col span={6}>
                    <InputBox title={'Domestic Margin (in INR)'}>
                      <Input
                        type={'number'}
                        value={flightMargins.domesticMargin}
                        className={'form-control'}
                        placeholder='Enter domestic margin'
                        addonBefore='₹'
                        onChange={(e) => _updateState({ domesticMargin: e.target.value })}
                      />
                    </InputBox>
                  </Col>
                  <Col span={6}>
                    <InputBox title={'International Margin (in INR)'}>
                      <Input
                        type={'number'}
                        value={flightMargins.internationalMargin}
                        className={'form-control'}
                        placeholder='Enter international margin'
                        addonBefore='₹'
                        onChange={(e) => _updateState({ internationalMargin: e.target.value })}
                      />
                    </InputBox>
                  </Col>
                </Row>

              </Card>
              <Card title={<b>Fixed Flight Margin</b>} className={'mt10'}>
                <Row gutter={24}>
                  <Col span={6}>
                    <InputBox title={'FD Domestic Margin (in INR)'}>
                      <Input
                        type={'number'}
                        value={flightMargins.fdDomestic}
                        className={'form-control'}
                        placeholder='Enter FD domestic margin'
                        addonBefore='₹'
                        onChange={(e) => _updateState({ fdDomestic: e.target.value })}
                      />
                    </InputBox>
                  </Col>
                  <Col span={6}>
                    <InputBox title={'FD International Margin (in INR)'}>
                      <Input
                        type={'number'}
                        value={flightMargins.fdInternational}
                        className={'form-control'}
                        placeholder='Enter FD international margin'
                        addonBefore='₹'
                        onChange={(e) => _updateState({ fdInternational: e.target.value })}
                      />
                    </InputBox>
                  </Col>
                </Row>

              </Card>
              <Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  className='btn'
                  onClick={handleSubmit}
                >
                  Update
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default UpdateXTravelExchangeMargin
